import { MenuItemCategory, MenuItemType } from "../../../../Components/navigationTypes"
import { CONST } from "../../../../SideDrawer/sideTypes"

export const drDocumentsList: Array<MenuItemType> = [
    {
        label: "New Home Connect",
        navigate: {
            component: "main",
        },
        subItems: [
            {
                label: "Project Information",
                navigate: {
                    component: "main",
                    params: {
                        "type": "file",
                        "id": CONST.uninitialized,
                    },
                    reactFrame: 'builderinfo',
                },
                addOptions: [],
                type: MenuItemCategory.Default,
            },
            {
                label: "Documents",
                navigate: {
                    component: "main",
                    params: {
                        "type": "file",
                        "id": CONST.uninitialized,
                    },
                    reactFrame: 'builderdoc',
                },
                addOptions: [],
                type: MenuItemCategory.Default,
            },
            {
                label: "Documents for eSigning",
                navigate: {
                    component: "main",
                    params: {
                        "id": CONST.uninitialized,
                        type: 'file',
                    },
                    reactFrame: 'builderesign',
                },
                addOptions: [],
                type: MenuItemCategory.Default,
            },
        ],
        addOptions: [],
        type: MenuItemCategory.Heading,
        icon: "fa-house"
    },
]